
import { useParams } from "react-router-dom";
import { Box, Grid } from "@mui/material";
import { CardProductoCompra, CargandoMedio, MensajeAlertaDanger } from "../../components";
import { LayoutCategoria } from "../../layouts";
import { useProductosXCategoria } from "../../../hooks/cache";
import { BuscadorXTermino } from "../../components/buscadores";




export const ExibirProductosCliente = () => {


    const { id } = useParams();
    const { data, isLoading, termino, chageTermino } = useProductosXCategoria(id);


    return (

        <Box sx={{width:'100%', px:5, py:4 }}>
            <LayoutCategoria titulo='Productos Por Categoria' add={false}>
                    {(isLoading)
                    ?   <CargandoMedio titulo="Cargando información de productos por categoria..." />
                    :   <>
                        <BuscadorXTermino mT={1} termino={termino} chageTermino={chageTermino} texto="productos" playhol="nombre de producto" />
                        
                        {(data?.length < 1)
                        ?   <MensajeAlertaDanger titulo="No hay información de productos..." />
        
                        :   <Grid container spacing={3} sx={{ display:'flex', alignItems:'stretch',mt:0.1 }}> 
                                {data.map(producto => ( 
                                    <CardProductoCompra key={producto.id} producto={producto} />
                                ))}
                            </Grid>
                        }
                        </>
                    }
            </LayoutCategoria>
        </Box>
    )
}
